<script setup lang="ts">
defineProps<{
  name: string
}>()
</script>
<template>
  <span class="material-symbols-outlined" translate="no">
    {{ name }}
  </span>
</template>
